import React from 'react';

const IconLogo = () => (
  <svg width={82} height={96} viewBox="0 0 82 96" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M41 3L2 25V70L41 93L80 71V26L41 3Z" fill="#0A192F" stroke="#64FFDA" strokeWidth={4} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.8656 45.8249C44.5757 45.1923 44.8403 44.4158 44.8403 43.4638C44.8403 42.5036 44.5685 41.7286 43.8573 41.0875C42.9963 40.3113 41.7993 40.1076 40.6892 40.1076H36.5485C36.5471 47.1253 36.529 54.1437 36.5438 61.1614L36.5456 62.0905H30.4483L30.4339 40.3603L28 40.3213V34H40.6556C43.3476 34 45.9807 34.6615 48.0323 36.5385C49.9868 38.326 50.8943 40.6645 50.8943 43.3324C50.8943 46 49.9904 48.3467 48.0244 50.1235C45.9692 51.9811 43.335 52.627 40.6556 52.627H39.7322L39.8603 48.0269C40.1506 47.9976 40.3141 46.8114 40.6051 46.7962C41.7624 46.7339 42.9083 46.6775 43.8656 45.8249Z"
      fill="#64FFDA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.6343 47.6976L40.6383 47.721H40.6892C42.0278 47.721 43.4169 47.4516 44.4562 46.5259C45.3641 45.7171 45.7425 44.6905 45.7425 43.464C45.7425 42.2355 45.3602 41.2093 44.4523 40.3909C43.4155 39.4563 42.0321 39.1806 40.6892 39.1806H35.6467C35.6467 45.3339 35.629 55.0102 35.6417 61.1635H31.3501L31.3349 39.4478L28.9021 39.4088V34.927H40.6556C43.1205 34.927 45.5515 35.5102 47.4327 37.231C49.1911 38.8397 49.9922 40.9255 49.9922 43.3326C49.9922 45.7379 49.1958 47.8304 47.4287 49.4272C45.5443 51.1306 43.1111 51.7004 40.6556 51.7004H40.6343V47.6976Z"
      fill="#64FFDA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M54 58.3226L49.994 63L36.5348 51.4767L40.5408 46.799L54 58.3226Z"
      fill="#64FFDA"
    />
  </svg>
);

export default IconLogo;
